// extracted by mini-css-extract-plugin
module.exports = {"exchange-record-header":"exchange-record-header-e6234fb9cb3aec99969c0e9c672555da","exchange-record-number":"exchange-record-number-9f507350fb6aa477c3804f944a2cc8e9"};